import { render, staticRenderFns } from "./profileSettings.vue?vue&type=template&id=0bb2f83f&scoped=true"
import script from "./profileSettings.vue?vue&type=script&lang=js"
export * from "./profileSettings.vue?vue&type=script&lang=js"
import style0 from "./profileSettings.vue?vue&type=style&index=0&id=0bb2f83f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb2f83f",
  null
  
)

export default component.exports